import React, { Component } from 'react';
import ByManager from './ByManager';
import ByCity from './ByCity';
import SideNav from '../UserSider';

class Manhour extends Component {
    state = {
        cur: 'manager',
        relateId: '',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur, relateId } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="output" openKeys={['sub2']}/>
                <div className="main">
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('manager')} className={cur == 'manager' ? 'curr' : ''} >
                                按主管
                            </a>
                            <a onClick={() => this.handleBtnClick('city')} className={cur == 'city' ? 'curr' : ''} >
                                按城市
                            </a>
                        </div>
                        { cur === 'manager' && <ByManager /> }
                        { cur === 'city' && <ByCity userFteSummaryId={relateId} /> }
                    </div>
                </div>
            </div>
        );
    }
}

export default Manhour;


// WEBPACK FOOTER //
// ./src/components/user/output/index.js